import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {MasterDetailRootModule} from '../../modules/master-detail-root/master-detail-root.module';
import {filter} from 'rxjs';
import {NgIf, NgStyle} from '@angular/common';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-new-login-page-adapter', // component is styled via global ng-deeps.scss, do not change the selector
  standalone: true,
    imports: [
        RouterOutlet,
        MasterDetailRootModule,
        NgIf,
        NgStyle
    ],
  templateUrl: './new-login-page-adapter.component.html',
  styleUrl: './new-login-page-adapter.component.scss'
})
export class NewLoginPageAdapterComponent implements OnInit {
    showFullMenu: boolean ;
    headerStyles: { color?: string, backgroundColor?: string, logoFilter?: string } = environment['headerStyles'];

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

    ngOnInit(): void {
        this.processRoute(this.activatedRoute);

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.processRoute(this.activatedRoute);
            });
    }

    private processRoute(route: ActivatedRoute): void {
        while (route.firstChild) {
            route = route.firstChild;
        }
        this.showFullMenu = route.snapshot.data['showFullMenu'] || false;
    }
}
